import {Injectable} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {VenueServices} from "./venue-services.data";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class VenueServicesService {
    constructor(private auth: AuthApiService, private http: HttpClient) {
    }

    async getVenueServices(venueId: string): Promise<VenueServices> {
        return firstValueFrom(this.http.get<VenueServices>("/fonzie/customer-instance-venue/" + venueId + "/venue-services", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async createVenueServices(venueId: string, services: VenueServices): Promise<VenueServices> {
        return firstValueFrom(this.http.post<VenueServices>("/fonzie/customer-instance-venue/" + venueId + "/venue-services", services, {headers: this.auth.getHttpHeaderOptions()}));
    }
}
